import type { FaireProductEntity } from "../../entity_types/product";

export const p_wapngd9v9a: FaireProductEntity = {
  token: "p_wapngd9v9a",
  type: "product",
  name: "Sandalwood Rose - 12.5 oz Large Concentrated Candle",
  brandToken: "b_a9b3b023",
  brandName: "P.F. Candle Co.",
  imageUrl:
    "https://cdn.faire.com/fastly/5ec2660545dbf8086d390eec13bd157e14479c3c9e4ff105dd9692c03ee020a9.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/849b1c9c59568fc9d941e0ffa11dab890b2b74c626a8fae01d04f083d9c9a38d.jpeg",
    "https://cdn.faire.com/fastly/df4f7b97fe07c7b4c28dacb8c8eee508a051fe5f27efd9253ff68c5d6a189726.jpeg",
    "https://cdn.faire.com/fastly/7ba43d641245d449d4258365aff390f6fe124e02eb7499cf0407de72973a1889.jpeg",
    "https://cdn.faire.com/fastly/b48261c329c9c9478c980b261afaf48c39fa55fb714f1b44e327a658aed86cc2.jpeg",
    "https://cdn.faire.com/fastly/afbe679981c3d3e032816803c911acc1445fb493b8af6041a885784071de9717.jpeg",
    "https://cdn.faire.com/fastly/2c0513b366ce92444a1ba54c40ea2665868f10ed7e7aa4b35faecbd9760f7e3f.jpeg",
  ],
  priceDollars: 18,
  description:
    "New York meets Los Angeles. Notes of cashmere rose, oud, and sandalwood.\n\nIntroducing our new and reformulated Large Concentrated Candles – we took our best-selling Classic Line scents and increased the fragrance level for stronger throw in your biggest spaces.\n\nOur 12.5 oz Large Candles are hand-poured into apothecary-inspired amber jars with our signature kraft label and a brass lid. \n\nOur candles are simple - they're all made with 100% domestically grown soy wax, fine fragrance oils, and cotton-core wicks. The fragrances we use are paraben-free, phthalate-free, and never (ever) tested on animals.\n\nBurns for 60-70 hours.",
  tags: [],
  msrpDollars: 37.99,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-07-23T04:51:54.331Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
